// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ERROR_COULD_NOT_PERFORM_ACTION = "Ups chyba, nepoda\u0159ilo se :(";
